import { Injectable } from '@angular/core';
import {
  EntityState,
  EntityStore,
  EntityUIStore,
  getEntityType,
  StoreConfig,
} from '@datorama/akita';
import { BehaviorSubject } from 'rxjs';

import { BudgetType, Category } from '@shared/services/gql.service';
import { RequireSome } from '@shared/utils/utils';

export type CategoryModel = getEntityType<CategoryState>;
export type CategoryState = EntityState<
  InMonthBudgetTypes &
    Omit<
      RequireSome<Partial<Category>, 'category_type' | 'id'>,
      | 'activities'
      | 'budget_forecast_settings'
      | 'categories'
      | 'total_accrual'
      | 'total_cost'
      | 'total_forecast'
      | 'total_wp'
    > & {
      activity_checked_count?: number;
      activity_ids: string[];
      primary_settings_id: string;
      secondary_settings_id: string;
      sub_categories: string[];
      sub_category_ids: string[];
    }
>;

export type CategoryUI = {
  isDetailFetched: boolean;
  isLoading: boolean;
  isOpen: boolean;
};

export type CategoryUIState = EntityState<CategoryUI>;

export type InMonthBudgetTypes = {
  [key in Exclude<BudgetType, BudgetType.BUDGET_MODEL>]?: {
    adjustment: number;
    total_accrual: number;
    total_cost: number;
    total_forecast: number;
    total_override: number;
    total_override_adjusted: number;
    total_wp: number;
  };
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'category' })
export class CategoryStore extends EntityStore<CategoryState> {
  hideActivitiesWithNoRemainingCost$ = new BehaviorSubject(false);
  hideForecastedActivities$ = new BehaviorSubject(false);
  ui!: EntityUIStore<CategoryUIState>;

  constructor() {
    super({});

    const defaultUiState: CategoryUI = {
      isDetailFetched: false,
      isLoading: false,
      isOpen: false,
    };

    this.createUIStore().setInitialEntityState(defaultUiState);
  }
}
